import type { OrbitControlsProps } from '@react-three/drei'
export default {
  orbitControls: {
    enableZoom: false,
    enablePan: false,
    enableRotate: false,
    enableDamping: false,
    minDistance: 0,
    maxDistance: 20,
    zoomSpeed: 1,
  } as OrbitControlsProps,
}
